import _scrollTo from 'scroll-to';

/**
 * Scrolls to the given element, offset by the header height.
 */
const scrollTo = (el) => {
  const bodyRect = document.body.getBoundingClientRect(),
        elemRect = el.getBoundingClientRect(),
        offset   = elemRect.top - bodyRect.top;

  _scrollTo(0, offset, {
    ease: 'out-circ',
    duration: 400
  });
};

export default {
  scrollTo
};



// WEBPACK FOOTER //
// ./src/utils/scroll.js